import * as React from 'react';
import { Nav as NavStrap } from 'reactstrap';
import { IComponentProps } from '../../common';

export interface NavProps extends IComponentProps {
    tabs?: boolean;
    pills?: boolean;
    vertical?: boolean | string;
    horizontal?: string;
    justified?: boolean;
    fill?: boolean;
    navbar?: boolean;
    card?: boolean;
    tag?: React.ReactType;
    className?: string;
}

export const Nav: React.FC<NavProps> = (props) => {
    return <NavStrap {...props} />
}

